module.exports = __webpack_public_path__ + "img/fresenius.a7583e0a.png";